export function request(args) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    const headers = args.headers || {}

    // TODO: set base url nicely
    xhr.open(args.method, `/api/v1${args.url}`, true)

    // Set request headers
    Object.keys(headers).forEach(function(key) {
      xhr.setRequestHeader(key, headers[key])
    })

    xhr.addEventListener('readystatechange', () => {
      if (xhr.readyState === 4) {
        if (xhr.status.toString().match(/^2[0-9]{2}$/)) {
          resolve(xhr)
        } else {
          reject(xhr)
        }
      }
    })

    xhr.send(args.data)
  })
}

export function authHeader(token) {
  return {
    authorization: `Bearer: ${token}`
  }
}
